
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Mayureshwar Ganpati Temple Morgaon" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Mayureshwar Ganpati Temple Morgaon" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Mayureshwar Temple, Mayureshwar Ganpati Morgaon, Ashtavinayak Ganpati Morgaon, Morgaon Ganpati Temple, Mayureshwar Vinayak Temple, Ashtavinayak Yatra Morgaon, Ganpati Temple Morgaon Pune, Mayureshwar Ganesh Temple Maharashtra, Ashtavinayak Pilgrimage Morgaon'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Mayureshwar Temple, Mayureshwar Ganpati Morgaon, Ashtavinayak Ganpati Morgaon, Morgaon Ganpati Temple, Mayureshwar Vinayak Temple, Ashtavinayak Yatra Morgaon, Ganpati Temple Morgaon Pune, Mayureshwar Ganesh Temple Maharashtra, Ashtavinayak Pilgrimage Morgaon, Morgaon Mayureshwar History, moreshwar ganpati temple, moreshwar ganpati distance, moreshwar temple at morgaon, pune to mayureshwar ganpati distance' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/mayureshwar.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/mayureshwar.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shree Mayureshwar Ganpati Temple Morgaon | Ashtavinayak - श्री मयूरेश्वर गणपती मोरगाव(अष्टविनायक)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/mayureshwar"
        },
        "headline": "Shree Mayureshwar Ganpati Temple Morgaon - श्री मयूरेश्वर गणपती मोरगाव(अष्टविनायक)",
        "name" : "Shree Mayureshwar Ganpati Temple Morgaon - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Mayureshwar Ganpati Temple Morgaon' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/mayureshwar.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  